import { Radio, RadioGroup, Stack } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'

const MSG = defineMessages({
  daily: {
    id: 'HomeSearch.listings.savedSearch.manageAlertsModal.daily',
    defaultMessage: 'Daily'
  },
  weekly: {
    id: 'HomeSearch.listings.savedSearch.manageAlertsModal.weekly',
    defaultMessage: 'Weekly'
  },
  never: {
    id: 'HomeSearch.listings.savedSearch.manageAlertsModal.never',
    defaultMessage: 'Never'
  }
})

interface SavedSearchAlertCadenceRadioButtonsProps {
  tracking: { guid: string; ui_context: string; descriptor: string }
}

export const SavedSearchAlertCadenceRadioButtons = ({ tracking }: SavedSearchAlertCadenceRadioButtonsProps) => {
  const intl = useIntl()
  return (
    <RadioGroup name='alertCadence' size='sm' tracking={tracking}>
      <Stack direction='column'>
        <Radio value='daily'>{intl.formatMessage(MSG.daily)}</Radio>
        <Radio value='weekly'>{intl.formatMessage(MSG.weekly)}</Radio>
        <Radio value='never'>{intl.formatMessage(MSG.never)}</Radio>
      </Stack>
    </RadioGroup>
  )
}
